//console.log("collections.js");

//Single Atc Button
let setSingleAtcBtn = function (singleProduct) {
  let singleAtcBtns = singleProduct.querySelectorAll(".single-atc-btn");

  if( singleAtcBtns.length === 0) {
  } else {
    singleAtcBtns.forEach((item) => {
      let idData = item.dataset.id;
      if (!idData) return;

      let singleID = parseInt(idData, 10);

      item.addEventListener("click", function (event) {
        event.preventDefault();

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            id: singleID,
            quantity: 1,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            window.coAccessibility?.openDialog(document.querySelector("#side-cart"), item);
            displayCart(); // make sure this function exists globally
          })
          .catch((error) => console.error("Error adding item to cart:", error));
      });
    });
  }
}

let removeShoeComma = function(singleProduct){
  let sizeButtons = singleProduct.querySelectorAll('.desktop-plp-add-to-cart.sizes .atc-btn');
  if (sizeButtons.length > 0) {
    const lastBtn = sizeButtons[sizeButtons.length - 1];
    lastBtn.textContent = lastBtn.textContent.replace(/,+\s*$/, '');
  }
}

//Swipe Images
const allProducts = document.querySelectorAll("#collection-con .product");

const setProduct = function (singleProduct) {
  let addSwiper = singleProduct.querySelector(".gallery-swiper");

  var swiper = new Swiper(addSwiper, {
    preloadImages: false,
    lazy: true,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });

  let plpAtc = singleProduct.querySelector(".plp-add-to-cart");

  if (plpAtc) {
    let togglePLPAtc = plpAtc.querySelector(".toggle-atc-btn");

    if (togglePLPAtc) {
      togglePLPAtc.addEventListener("click", function (event) {
        event.preventDefault();
        plpAtc.classList.add("active");
      });
    }
  }

  setSingleAtcBtn(singleProduct);
  removeShoeComma(singleProduct);

  singleProduct.dataset.status = "dynamic";
};

window.addEventListener("load", function () {
  document.querySelectorAll("#collection-con .product").forEach(setProduct);

  const collectionCon = document.querySelector("#collection-con");
  const nextBtn = document.querySelector("#paginate-next");
  const loadMoreBtn = document.querySelector(".load-more-btn");
  const pagination = document.querySelector(".pagination");
  let nextUrl = nextBtn?.getAttribute("href");
  let loading = false;

  if (nextUrl && collectionCon) {
    const trigger = document.createElement("div");
    trigger.id = "scroll-trigger";
    trigger.style.height = "1px";
    pagination.parentNode.insertBefore(trigger, pagination);

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
      triggerElement: "#scroll-trigger",
      triggerHook: 1
    })
      .addTo(controller)
      .on("enter", function () {
        if (!loading && nextUrl) {
          loading = true;
          fetchNextPage(nextUrl);
        }
      });
  }

  function fetchNextPage(url) {
    fetch(url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newProducts = doc.querySelectorAll("#collection-con .product");
        const newNextBtn = doc.querySelector("#paginate-next");

        newProducts.forEach(product => {
          collectionCon.appendChild(product);
          setProduct(product);
        });

        if (newNextBtn) {
          nextUrl = newNextBtn.getAttribute("href");
        } else {
          nextUrl = null;

          // Final page reached
          pagination?.remove();
          if (loadMoreBtn) {
            loadMoreBtn.classList.add("hide");
          }
        }

        // Extra safety: if no products were added at all
        if (newProducts.length === 0) {
          nextUrl = null;
          pagination?.remove();
          if (loadMoreBtn) {
            loadMoreBtn.classList.add("hide");
          }
        }

        loading = false;
      })
      .catch(err => {
        console.error("Failed to fetch next page:", err);
        loading = false;
      });
  }
});

//Filters
let filters = document.querySelector("#main-filters");
let openFiltersBtn = document.querySelectorAll(".filters-btn");
let closeFiltersBtn = document.querySelectorAll(".close-filters-btn");
let filtersSidePop = document.querySelector(".filters-side-pop");
let lastFiltersTrigger = null;

openFiltersBtn.forEach(function (btn) {
  btn.addEventListener("click", function (event) {
    event.preventDefault();
    lastFiltersTrigger = btn;
    filtersSidePop.classList.add("active");
    filtersSidePop.setAttribute("aria-hidden", "false");
    filtersSidePop.removeAttribute("inert");
    btn.setAttribute("aria-expanded", "true");
    document.body.classList.add("no-scroll");
    filtersSidePop.querySelector(".close-filters-btn")?.focus();
  });
});

closeFiltersBtn.forEach(function (btn) {
  btn.addEventListener("click", function (event) {
    event.preventDefault();
    filtersSidePop.classList.remove("active");
    filtersSidePop.setAttribute("aria-hidden", "true");
    filtersSidePop.setAttribute("inert", "");
    openFiltersBtn.forEach(function (button) {
      button.setAttribute("aria-expanded", "false");
    });
    document.body.classList.remove("no-scroll");
    if (lastFiltersTrigger && document.contains(lastFiltersTrigger)) {
      lastFiltersTrigger.focus();
    }
    lastFiltersTrigger = null;
    Cookies.remove('filter-state');
    let checkFilterState = Cookies.get('filter-state');
    console.log(checkFilterState);
  });
});

if (filtersSidePop) {
  filtersSidePop
    .querySelectorAll("details.filter-block")
    .forEach(function (group) {
      function syncFilterGroup() {
        group.classList.toggle("open", group.open);
      }

      group.addEventListener("toggle", syncFilterGroup);
      syncFilterGroup();
    });
}

document.querySelectorAll('.filter-form input[type="checkbox"]').forEach((checkbox) => {
  checkbox.addEventListener('change', () => {
    const form = document.querySelector('.filter-form');
    const resultsCount = document.querySelector('#results-count');

    // Show loading state
    if (resultsCount) {
      resultsCount.innerHTML = '...';
    }

    // Build URL from current selected filters
    const params = new URLSearchParams(new FormData(form));

    // Get current sort if needed
    const sortParam = new URLSearchParams(window.location.search).get('sort_by');
    if (sortParam) params.set('sort_by', sortParam);

    const url = `${window.location.pathname}?${params.toString()}`;

    // Fetch filtered page
    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Grab updated count from new page
        const newCount = doc.querySelector('#results-count');
        if (newCount && resultsCount) {
          resultsCount.innerHTML = newCount.innerHTML;
        }
      })
      .catch((err) => {
        console.error("Error fetching filtered results:", err);
        if (resultsCount) {
          resultsCount.innerHTML = 'Error';
        }
      });
  });
});


//Views
let toggleView = document.querySelector(".toggle-view");
let collectionCon = document.querySelector("#collection-con"); // Updated selector

if (toggleView && collectionCon) {
  let viewBtn = toggleView.querySelector(".view-btn");
  let toggleBtns = toggleView.querySelectorAll(".toggle-btn");

  function updateCollectionView(activeBtn) {
    // Remove all existing view classes
    collectionCon.classList.remove("two-view", "four-view", "six-view");

    // Apply the correct class based on the active button
    if (activeBtn.classList.contains("two-view")) {
      collectionCon.classList.add("two-view");
    } else if (activeBtn.classList.contains("four-view")) {
      // If four-view is active, reset to default (no extra class)
    } else if (activeBtn.classList.contains("six-view")) {
      collectionCon.classList.add("six-view");
    }

    toggleBtns.forEach(function (button) {
      button.setAttribute(
        "aria-pressed",
        button === activeBtn ? "true" : "false",
      );
    });
  }

  // Cycle through views when clicking viewBtn
  viewBtn.addEventListener("click", function (e) {
    e.preventDefault(); // Prevent default link behavior

    let activeIndex = 0; // Start with 0, knowing there is always an active button

    // Find the index of the currently active toggle button
    for (let i = 0; i < toggleBtns.length; i++) {
      if (toggleBtns[i].classList.contains("active")) {
        activeIndex = i;
        break; // Stop looping once found
      }
    }

    // Remove active class from the current button
    toggleBtns[activeIndex].classList.remove("active");

    // Determine the next index, cycling back to 0 if at the last button
    let nextIndex = (activeIndex + 1) % toggleBtns.length; // Ensure cycling behavior

    // Add active class to the next button
    let nextBtn = toggleBtns[nextIndex];
    nextBtn.classList.add("active");

    // Update #collection-con class
    updateCollectionView(nextBtn);
  });

  // Add click event listeners to individual toggle buttons
  toggleBtns.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault(); // Prevent default link behavior

      // Remove active class from all buttons
      toggleBtns.forEach((b) => b.classList.remove("active"));

      // Add active class to the clicked button
      btn.classList.add("active");

      // Update #collection-con class
      updateCollectionView(btn);
    });
  });
}

  let homeSwipers = document.querySelectorAll(".collection-swiper");

  if (homeSwipers.length > 0) {
    homeSwipers.forEach((homeSwiper) => {
      new Swiper(homeSwiper, {
        //preloadImages: false,
        loop: true,
        slidesPerView: 2,
        spaceBetween: 2,
        draggable: true,
        freeMode: true,
        mousewheel: {
          forceToAxis: true,
        },
        //spaceBetween: 24,
        wrapperClass: "collection-wrapper",
        slideClass: "collection-slide",
        navigation: {
          nextEl: ".arrows .right",
          prevEl: ".arrows .left",
        },
        breakpoints: {
          600: {
            slidesPerView: 2,
            spaceBetween: 2,
          },
          880: {
            slidesPerView: 3,
            spaceBetween: 2,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 2,
          },
        },
        on: {
          init: function () {
            // Add class to all slides inside this Swiper instance
            this.slides.forEach((slide) => {
              slide.classList.add("finished-loading");
            });
          },
        },
      });
    });
  }

    // document.addEventListener("DOMContentLoaded", function () {
    //   const params = new URLSearchParams(window.location.search);
    //   if (
    //     window.location.pathname === "/collections/sale" &&
    //     params.get("page") === "4"
    //   ) {
    //     window.location.replace("/collections/sale");
    //   }
    // });
